<ul class="nav nav-tabs justify-content-center">
  <li class="nav-item">
    <a
      class="nav-link"
      title="Reports Dashboard"
      href="javascript:void(0)"
      [routerLink]="'/reporting'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Reports Dashboard</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      title="Support Insights"
      href="javascript:void(0)"
      [routerLink]="'/reporting/support-insights'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Support Insights</a
    >
  </li>
  <li *ngIf="evidenceReportEnabled" class="nav-item">
    <a
      class="nav-link"
      title="Evidence"
      href="javascript:void(0)"
      [routerLink]="'/reporting/evidence'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Evidence</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      title="Growth"
      href="javascript:void(0)"
      [routerLink]="'/reporting/badge-progress'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Growth</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      title="Observation Report"
      href="javascript:void(0)"
      [routerLink]="'/reporting/observations'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Observation Report</a
    >
  </li>
  <ng-container *ngIf="PDReportsEnabled">
    <li class="nav-item">
      <a
        class="nav-link"
        title="Staff Member Credits Earned"
        href="javascript:void(0)"
        [routerLink]="'/reporting/credits-earned'"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        ariaCurrentWhenActive="page"
        aria-current="page"
        >Credits Earned</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        title="Learning & Events"
        href="javascript:void(0)"
        [routerLink]="'/reporting/pd-session-summary'"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        ariaCurrentWhenActive="page"
        aria-current="page"
        >Learning & Events</a
      >
    </li>
  </ng-container>
  <li class="nav-item">
    <a
      class="nav-link"
      title="Session Details"
      href="javascript:void(0)"
      [routerLink]="'/reporting/session-details'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Session Details</a
    >
  </li>
</ul>
